import styled from "styled-components";

import free from '@/images/every-day-btn.png'
import freeHover from '@/images/every-day-btn-hover.png'
import freeEnd from '@/images/every-day-btn-end.png'

import circle from '@/images/btn-circle.png'
import circleHover from '@/images/btn-circle-hover.png'
import circleEnd from '@/images/btn-circle-end.png'

import getBtn from '@/images/month-btn.png'
import getBtnHover from '@/images/month-btn-hover.png'
import getBtnEnd from '@/images/month-btn-end.png'

import discount from '@/images/vip-discount.png'
import discountHover from '@/images/vip-discount-hover.png'
import origin from '@/images/vip-origin.png'
import originHover from '@/images/vip-origin-hover.png'

import modalBtn1 from '@/images/modal-btn1.png'
import modalBtn1Hover from '@/images/modal-btn1-hover.png'
import modalBtn2 from '@/images/modal-btn2.png'
import modalBtn2Hover from '@/images/modal-btn2-hover.png'
import modalBtn3 from '@/images/modal-btn3.png'
import modalBtn3Hover from '@/images/modal-btn3-hover.png'
import modalBtn4 from '@/images/modal-btn4.png'
import modalBtn4Hover from '@/images/modal-btn4-hover.png'

function getStyle(attr, type) {
  switch (attr) {
    case 'width':
      return [185, 76, 99, 180, 171, 171, 171, 171, 171][type]
    case 'height':
      return [71, 75, 39, 73, 64, 64, 64, 64, 64][type]
    case 'backgroundImage':
      return [
        [
          {0: free, 1: free, 100: freeEnd},
          {0: freeHover, 1: freeHover, 100: freeEnd}
        ],
        [
          {0: circle, 1: circle, 100: circleEnd},
          {0: circleHover, 1: circleHover, 100: circleEnd}
        ],
        [
          {0: getBtn, 1: getBtn, 100: getBtnEnd},
          {0: getBtnHover, 1: getBtnHover, 100: getBtnEnd}
        ],
        [discount, discountHover],
        [origin, originHover],
        [modalBtn1, modalBtn1Hover],
        [modalBtn2, modalBtn2Hover],
        [modalBtn3, modalBtn3Hover],
        [modalBtn4, modalBtn4Hover]
      ][type]
  }
}

const Index = styled.div.attrs(props => ({
  className: 'button',
  type: props.type,
  status: props.status,
  width: getStyle('width', props.type),
  height: getStyle('height', props.type),
  backgroundImage: getStyle('backgroundImage', props.type),
}))`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  background-image: url("${props => (props.status === undefined ? props.backgroundImage[0] : props.backgroundImage[0][props.status])}");
  background-repeat: no-repeat;
  background-position: left top;
  //transition: background-image 0.2s;
  display: inline-block;
  cursor: pointer;

  &:hover {
    background-image: url("${props => (props.status === undefined ? props.backgroundImage[1] : props.backgroundImage[1][props.status])}");
  }
`;

export default Index

